import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "actions", "actionThumbnails"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, useContext } from 'react';
import { prefix } from '../../../tools/settings';
import cx from 'classnames';
import styled from 'styled-components';
import Button from '../../Button';
import Icon from '../../Icon';
import Image from '../../Image';
import Link from '../../Link';
import Thumbnail from './Thumbnail';
import { CardContext } from '../Card';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledFooter = styled.div.withConfig({
  displayName: "Actions__StyledFooter",
  componentId: "sc-kum5jb-0"
})(["margin-top:auto;position:relative;"]);
var StyledActions = styled.div.withConfig({
  displayName: "Actions__StyledActions",
  componentId: "sc-kum5jb-1"
})(["display:flex;flex-direction:row;align-items:center;margin-top:var(--dentsu-spacing-8);.", "-card--editorial &{flex-direction:column;justify-content:center;margin-top:var(--dentsu-spacing-16);}.", "-card--action &,.", "-card--functional &{justify-content:flex-end;}.", "-card--connection &{justify-content:space-between;margin-top:var(--dentsu-spacing-16);}.", "-card--media &{border-top:1px solid var(--dentsu-color-n200);justify-content:space-between;margin-top:0;padding:var(--dentsu-spacing-8) var(--dentsu-spacing-16);height:52px;text-align:left;.", "-icon{margin-left:auto;}}.", "-link{margin-left:var(--dentsu-spacing-24);}.", "-card__actionIndicator{margin-left:auto;}"], prefix, prefix, prefix, prefix, prefix, prefix, prefix, prefix);
var Actions = forwardRef(function (_ref, ref) {
  var children = _ref.children,
      actionsFromProp = _ref.actions,
      actionThumbnailsFromProp = _ref.actionThumbnails,
      rest = _objectWithoutProperties(_ref, _excluded);

  var className = cx(_defineProperty({}, "".concat(prefix, "-card__actions"), true));

  var _useContext = useContext(CardContext),
      cardVariant = _useContext.variant;

  var isFunctional = cardVariant === 'functional',
      isEditorial = cardVariant === 'editorial',
      isAction = cardVariant === 'action',
      isMedia = cardVariant === 'media',
      isConnection = cardVariant === 'connection';
  return _jsx(StyledFooter, {
    children: _jsxs(StyledActions, _objectSpread(_objectSpread({
      ref: ref,
      className: className
    }, rest), {}, {
      children: [actionsFromProp && isFunctional && actionsFromProp.map(function (action, index) {
        var _action$as;

        var actionType = (_action$as = action === null || action === void 0 ? void 0 : action.as) !== null && _action$as !== void 0 ? _action$as : 'link';

        if (actionType === 'button') {
          var _action$variant, _action$size;

          return _jsx(Button, {
            id: action === null || action === void 0 ? void 0 : action.id,
            iconLeft: action === null || action === void 0 ? void 0 : action.iconLeft,
            iconRight: action === null || action === void 0 ? void 0 : action.iconRight,
            isDisabled: action === null || action === void 0 ? void 0 : action.isDisabled,
            isLoading: action === null || action === void 0 ? void 0 : action.isLoading,
            isExternal: action === null || action === void 0 ? void 0 : action.isExternal,
            onClick: action === null || action === void 0 ? void 0 : action.onClick,
            onBlur: action === null || action === void 0 ? void 0 : action.onBlur,
            variant: (_action$variant = action === null || action === void 0 ? void 0 : action.variant) !== null && _action$variant !== void 0 ? _action$variant : 'secondary',
            size: (_action$size = action === null || action === void 0 ? void 0 : action.size) !== null && _action$size !== void 0 ? _action$size : 'medium',
            children: action.label
          }, index);
        } else {
          return _jsx(Link, {
            id: action === null || action === void 0 ? void 0 : action.id,
            iconLeft: action === null || action === void 0 ? void 0 : action.iconLeft,
            iconRight: action === null || action === void 0 ? void 0 : action.iconRight,
            isDisabled: action === null || action === void 0 ? void 0 : action.isDisabled,
            isExternal: action === null || action === void 0 ? void 0 : action.isExternal,
            onClick: action === null || action === void 0 ? void 0 : action.onClick,
            url: action === null || action === void 0 ? void 0 : action.url,
            children: action.label
          }, index);
        }
      }), actionsFromProp && isEditorial && actionsFromProp.map(function (action, index) {
        var _action$variant2, _action$size2;

        return _jsx(Button, {
          id: action === null || action === void 0 ? void 0 : action.id,
          iconLeft: action === null || action === void 0 ? void 0 : action.iconLeft,
          iconRight: action === null || action === void 0 ? void 0 : action.iconRight,
          isDisabled: action === null || action === void 0 ? void 0 : action.isDisabled,
          isLoading: action === null || action === void 0 ? void 0 : action.isLoading,
          isExternal: action === null || action === void 0 ? void 0 : action.isExternal,
          onClick: action === null || action === void 0 ? void 0 : action.onClick,
          onBlur: action === null || action === void 0 ? void 0 : action.onBlur,
          variant: (_action$variant2 = action === null || action === void 0 ? void 0 : action.variant) !== null && _action$variant2 !== void 0 ? _action$variant2 : 'secondary',
          size: (_action$size2 = action === null || action === void 0 ? void 0 : action.size) !== null && _action$size2 !== void 0 ? _action$size2 : 'medium',
          children: action.label
        }, index);
      }), actionsFromProp && isMedia && _jsx(_Fragment, {
        children: actionsFromProp.map(function (action, index) {
          return (action === null || action === void 0 ? void 0 : action.label) && action.label;
        })
      }), !actionsFromProp && children, actionThumbnailsFromProp && actionThumbnailsFromProp.map(function (thumbnail, index) {
        var _thumbnail$isRounded;

        return _jsx(Thumbnail, {
          children: _jsx(Image, {
            htmlWidth: 32,
            height: 32,
            objectFit: "contain",
            isRounded: (_thumbnail$isRounded = thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.isRounded) !== null && _thumbnail$isRounded !== void 0 ? _thumbnail$isRounded : true,
            src: thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.src,
            alt: thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.name
          })
        }, index);
      }), (isAction || isConnection || isMedia) && _jsx(Icon, {
        className: "".concat(prefix, "-card__actionIndicator"),
        icon: "chevron-right",
        size: 18,
        color: "var(--dentsu-color-blue)"
      })]
    }))
  });
});
export default Actions;